import { render, staticRenderFns } from "./deepAnalytics.vue?vue&type=template&id=70feb046&scoped=true"
import script from "./deepAnalytics.vue?vue&type=script&lang=js"
export * from "./deepAnalytics.vue?vue&type=script&lang=js"
import style0 from "./deepAnalytics.vue?vue&type=style&index=0&id=70feb046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70feb046",
  null
  
)

export default component.exports